import { StatisticsIndex, StatisticsDetails } from "../views";

export const statisticsRouter = [
  {
    name: "StatisticsIndex",
    path: "statistics/",
    component: StatisticsIndex
  },
  {
    name: "StatisticsDetails",
    path: "statistics/details",
    component: StatisticsDetails,
    props: true
  }
];
